
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.533 14.381l.057-.2.1-.38 1.797.68a1.28 1.28 0 00-.233-.68l-1.426-1.084a15.44 15.44 0 00.314-2.434V8.71l.066-.647h1.426l3.804 1.574s.637.323.637.57a.781.781 0 00-.186-.684c-.109-.1-4.169-3.057-4.169-3.057l.1-.2h.109a2.99 2.99 0 00.119-.803c0-.428-.171-.475-.171-.475h-.475s-.21 0-.21.337c.015.295.058.588.129.875l-.951-.737a.863.863 0 01-.257-.385V2.972S8.032.5 7.5.5s-.613 2.472-.613 2.472v2.125a.863.863 0 01-.257.385l-.951.737a4.62 4.62 0 00.129-.875c0-.356-.21-.337-.21-.337h-.475s-.171.047-.171.475c.003.272.043.542.119.803h.109l.1.2S1.22 9.442 1.111 9.542a.781.781 0 00-.186.684c0-.247.637-.57.637-.57l3.804-1.574h1.426l.066.647v1.573c.04.819.145 1.633.314 2.434L5.746 13.82a1.28 1.28 0 00-.233.68l1.797-.68.1.381.123.18z"}})])
          )
        }
      }
    